
import { getConfig } from '@/api/wx.js'
import wx from 'weixin-js-sdk'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import config from '@/config/index'
import { getProductDetail } from '@/api/youzheng.js'
import { getintegral } from '@/api/user.js'
import { getpjlist, updatePageViews, timePanduan } from '@/api/mall.js'
import { wxShare } from '@/libs/utils.js'
import failimg from '@/assets/integralmall/timg.jpg'
import errorImg from '@/assets/mall/img-error.png'
export default {
name: 'productdetail',
components: {
XButton,
Divider,
Swiper
},
data () {
return {
searchVal: '',
failimg: failimg,
baseUrl: config.baseUrl,
errorImg: errorImg,
id: this.$route.params.id,
goodsObj: {},
owner_type: config.owner_type,
num: '',
pageCurrent: 1,
pageSize: 1,
list: '',
filepaths: '',
iscurrent: true
}
},
created () {
this.wxconfig()
this.getDetail()
this.getpjlistNow()
this.getpanduan()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {

getpanduan () {
timePanduan({
id: this.id
}).then(data => {
if (!data.obj) {
this.iscurrent = false
}
})
},
onImgError ($event) {
$event.target.src = this.errorImg
},
getDetail () {
getProductDetail({
productid: this.id
}).then(res => {
this.goodsObj = res.returnValue
const link = window.location.href
const wxShareLink = this.baseUrl + 'servlet/ShareServlet?sicode=' + config.sicode + '&url=' + link
wxShare(res.returnValue.PRODNAME, wxShareLink, this.baseUrl + res.returnValue.TITLEIMG)
})
},

confirm () {






this.$router.push({ name: 'mall2SubmitSApikeOrders', params: { id: this.id } })

},

getTotalCredit () {
getintegral({
accountid: this.accountid,
owner_type: '',
userid: this.userid
}).then(res => {
if (res.returnValue.allnow < this.goodsObj.CREDIT) {
this.$vux.alert.show({
content: '您的当前积分不足，不能兑换！'
})
return false
} else {
this.$router.push({ name: 'mall2SubmitSApikeOrders', params: { id: this.id } })
}
})
},

getpjlistNow () {
getpjlist({
productid: this.id,
pageCurrent: this.pageCurrent,
pageSize: this.pageSize
}).then(data => {
this.list = data.obj
this.num = data.obj.num2 + data.obj.num3
if (data.obj.newList.length != 0) {
this.filepaths = data.obj.newList[0].filepaths.slice(0, 3)
}
})
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['previewImage'] 
})
})
},

preview (index, fileList, pageViews, id) {
let arr = fileList.map(item => this.baseUrl + item)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
this.updatePageViewsNow(pageViews, id)
},
updatePageViewsNow (pageViews, id) {
updatePageViews({
id: id,
pageViews: pageViews
})
},
linkpj () {
this.$router.push({ name: 'mall2pingjia' })
}
}
}
